"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconSwitch = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M4.002 20.446h2.15v-2.773l.396.377c.844.805 1.74 1.406 2.69 1.803s1.931.595 2.943.595c1.895 0 3.594-.581 5.099-1.743 1.504-1.162 2.487-2.656 2.949-4.482h-2.281a5.878 5.878 0 0 1-2.218 2.955 6.006 6.006 0 0 1-3.55 1.12 5.847 5.847 0 0 1-3.897-1.502l-.435-.434h2.388v-2.15H4.002v6.234Zm.22-10.223h2.28A5.878 5.878 0 0 1 8.72 7.268a6.006 6.006 0 0 1 3.55-1.12 5.848 5.848 0 0 1 3.897 1.502l.435.435h-2.389v2.15h6.235V4h-2.15v2.773l-.396-.377c-.825-.824-1.716-1.43-2.676-1.817a7.836 7.836 0 0 0-2.957-.58c-1.895-.001-3.594.58-5.099 1.742-1.504 1.162-2.487 2.656-2.949 4.482Z"
}));
exports.IconSwitch = IconSwitch;
//# sourceMappingURL=IconSwitch.js.map